import accessControlDefinitions from './access-control-definition'

export type CanSections =
  | 'WorkManagement'
  | 'Admin'
  | 'Content'
  | 'Dashboard'
  | 'Help'
  | 'Inbox'
  | 'Notifications'
  | 'Objects'
  | 'Search'
  | 'Settings'
  | 'Tasks'
  | 'Teams'
  | 'Support'
  | 'Profile.PersonalInformation'
  | 'Profile.Password'
  | 'Profile.Notifications'
  | 'Profile.Security'
  | 'Profile.Log'
  | 'Modules.Customer'
  | 'Modules.Customer.Contacts'
  | 'Modules.Customer.Comments'
  | 'Modules.Customer.Responsibles'
  | 'Modules.Customer.Address'
  | 'Modules.Customer.Station'
  | 'Modules.Customer.TechnicalInformation'
  | 'Modules.MyCustomers'
  | 'Modules.Gps'
  | 'Modules.Inspection'
  | 'Modules.PeriodicCheck'
  | 'Modules.Responsible'
  | 'Modules.Responsible.Comments'
  | 'Modules.Responsible.Contacts'
  | 'Modules.Responsible.Information'
  | 'Modules.Support'
  | 'MainMenu.Home'
  | 'MainMenu.WorkManagement'
  | 'MainMenu.Notifications'
  | 'MainMenu.Inbox'
  | 'MainMenu.Tasks'
  | 'MainMenu.Support'
  | 'SubMenu.Help'
  | 'SubMenu.Search'
  | 'ProfileMenu.MyProfile'
  | 'ProfileMenu.Admin'
  | 'ProfileMenu.Content'
  | 'ProfileMenu.Objects'
  | 'ProfileMenu.Teams'
  | 'ProfileMenu.SignOut'
  | 'AdminMenu.General'
  | 'AdminMenu.Customization'
  | 'AdminMenu.User'
  | 'AdminMenu.Security'
  | 'AdminMenu.Permissions'
  | 'AdminMenu.Database'
  | 'AdminMenu.Reports'
  | 'AdminMenu.Enargas'
  | 'CustomerMenu.Download'

interface CanProps {
  profile: string
  role: string
  section: CanSections
  action: 'view' | 'create' | 'edit' | 'delete' | 'edit:own' | 'delete:own' | 'view:own';
}

export const can = ({ profile, role, section, action }: CanProps) => {
  if (role && profile && section && action) {
    // console.log({ 'selected-section-actions:': accessControlDefinitions[role][profile][section].actions, 'can-or-not:': accessControlDefinitions[role][profile][section].actions.includes(action) })
    // // Implement logic to check if user has access to the given section


    const permissions = accessControlDefinitions[role][profile][section]?.actions

    if (!permissions) {
      // role is not present in the rules
      return false
    }

    // const staticPermissions = permissions.static;

    // if (staticPermissions && staticPermissions.includes(action)) {
    //   // static rule not provided for action
    //   return true;
    // }

    // const dynamicPermissions = permissions.dynamic;

    // if (dynamicPermissions) {
    //   const permissionCondition = dynamicPermissions[action];
    //   if (!permissionCondition) {
    //     // dynamic rule not provided for action
    //     return false;
    //   }

    //   return permissionCondition(data);
    // }

    return permissions.includes(action)
  }

  return false
}
